// extracted by mini-css-extract-plugin
export default {"issueItem":"SidebarTabProgressIssueItem_issueItem__VR55U"};